import { Component, OnDestroy, OnInit, Input, EventEmitter, Output, signal } from '@angular/core';
import { ClientInformation } from 'src/app/models/client-information';
import { Subject, takeUntil } from 'rxjs';
import { ClientIntegrationService } from 'src/app/services/client-integration.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DynamicDropdownViewComponent } from '../dynamic-dropdown-view/dynamic-dropdown-view.component';
import { LTSpinnerComponent } from 'src/app/features/lt-shared-ui/lt-info/components/lt-spinner/lt-spinner.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-client-dropdown-view',
  imports: [
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    DynamicDropdownViewComponent,
    LTSpinnerComponent,
    CommonModule,
  ],
  templateUrl: './client-dropdown-view.component.html',
  styleUrl: './client-dropdown-view.component.scss',
})
export class ClientDropdownViewComponent implements OnInit, OnDestroy {
  destroyed$: Subject<boolean> = new Subject();

  @Input() clients: ClientInformation[] | null = null;
  @Input() labelName = 'Client';
  @Input() overrideItem: ClientInformation | null = null;
  @Input() overrideItemId: string | null = null;
  @Input() noItemsMessage = 'No clients available.';

  @Output() itemSelected = new EventEmitter<ClientInformation | null>();
  @Output() loadingFailed = new EventEmitter<any>();
  @Output() itemSelectedFromOverride = new EventEmitter<ClientInformation | null>();

  selectedItem = signal<ClientInformation | null>(null);
  hasItems = false;

  constructor(
    private readonly clientService: ClientIntegrationService) { }

  ngOnInit(): void {
    this.getClients();
  }

  getClients(): void {
    this.hasItems = false;
    if (this.clients != null && this.clients.length > 0)
    {
      this.clients = this.clients.sort((a,b) => a.clientDisplayName.localeCompare(b.clientDisplayName));
      this.hasItems = true;
    }
    else {
      this.clientService.getAllClients()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data) => {
        if (data == null || data.length === 0)
        {
          this.loadingFailed.emit();
        }
        else {
          this.clients = data;
          this.clients = this.clients.sort((a,b) => a.clientDisplayName.localeCompare(b.clientDisplayName));
          this.hasItems = true;
        }
      });
    }
  }

  editItem(): void {
    this.selectedItem.set(null);
    this.itemSelected.emit(null);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  selectItemForOverride(item: ClientInformation): void {
    this.selectedItem.set(item);
    this.itemSelectedFromOverride.emit(this.selectedItem());
  }

  selectItem(item: ClientInformation): void {
    this.selectedItem.set(item);
    this.itemSelected.emit(item);
  }

  public displayItem(item: ClientInformation): string {
    return item?.clientDisplayName ?? '';
  }
}
